module.exports = __webpack_public_path__ + "img/select-arrow.efc9333e.svg";